<template>
  <v-dialog v-model="dialog" width="36%" height="40%" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>TỔNG KẾT LẠI</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-col class="pt-6 px-6">
        <v-form ref="form">
          <v-radio-group v-model="reSummaryType">
            <v-radio value="default" label="Theo nhóm" />
            <v-radio value="specific" label="Theo đối tượng cụ thể" />
          </v-radio-group>
          <v-row v-if="reSummaryType === 'default'">
            <v-col cols="12" md="6" class="pb-10">
              <v-autocomplete
                v-model="group"
                item-text="title"
                clear-icon="mdi-close"
                :items="groups"
                label="Nhóm đối tượng"
                clearable
                outlined
                dense
                return-object
                required
                :loading="loading"
                :rules="[rule]"
                class="required style"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <ReSummarySpecific @onSave="cancel" />
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn width="97px" outlined class="ma-2" @click="cancel">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text text-uppercase" @click="save">Tổng kết lại</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import { textHelpers } from '../../../helpers/TextHelper'
import ReSummarySpecific from './resummary-specific/index.vue'

export default {
  components: { ReSummarySpecific },
  data() {
    return {
      rule: this.$rules.required,
      dialog: false,
      group: {},
      groups: [],
      loading: false,
      reSummaryType: 'default'
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters({
      period: 'salaryPeriod/period'
    })
  },
  async created() {
    this.groups = await this.fetchAll({})
  },
  watch: {
    period() {
      if (this.period.status === 'running') {
        this.setLoadingFee(true)
      }
    }
  },
  methods: {
    ...mapActions('salaryReport', ['fetchAll']),
    ...mapActions('salaryHead', ['fetchTuitionGroup', 'createGroupHeadFee', 'setRouter']),
    ...mapActions('salaryGroup', ['fetchGroups']),
    ...mapActions('salaryPeriod', ['reSummary', 'setLoadingFee']),
    cancel() {
      this.dialog = false
      this.reset()
    },
    async save() {
      if (this.group && this.group.id) {
        this.$dialog.confirm({
          title: 'Xác nhận tổng kết lại?',
          text:
            'Thao tác này có thể mất một chút thời gian. Thông tin cũ có thể bị thay đổi và không thể hoàn tác. Bạn muốn tiếp tục tổng kết lại?',
          okText: 'Xác nhận',
          cancelText: 'Hủy',
          done: async () => {
            try {
              await this.reSummary({
                status: 'running',
                type: this.group.defaultType || 'custom',
                typeId: this.group.id,
                id: this.period.id,
                generatedBy: this.user.id
              })
              this.dialog = false
              this.reset()
            } catch (e) {
              this.$alert.error(e)
            }
          }
        })
      } else {
        this.$refs.form.validate()
      }
    },
    openDialog() {
      this.dialog = true
    },
    reset() {
      this.loading = false
      this.group = {}
      this.groups = []
      this.$refs.form.reset()
    }
  }
}
</script>
